import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import servicosProduto from "../../servicos/servicos-produto";
import { Form } from "semantic-ui-react";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { ToastContainer, toast } from 'react-toastify';
import Edit from "../../img/svgs/Edit";
import Cancel from "../../img/svgs/Cancel";
import Salvar from "../../img/svgs/Salvar";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";
import servicosImagens from "../../servicos/servicos-imagens";
import { useNavigate } from "react-router-dom";
import { basePath } from "../../utils/baseUrl";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import ShareIcon from '@mui/icons-material/Share';
import ExcelJS from 'exceljs';

const ListProdutos = () => {
  const [produtos, setProdutos] = useState([]);
  const [valor, setValor] = useState();
  const [editado, setEditado] = useState(false)
  const [show, setShow] = useState(false);
  const [idProduto, setIdProduto] = useState();
  const nome = useRef();
  const tamanho = useRef();
  const cor = useRef();
  const estoque = useRef();
  const milhas = useRef();
  const categoria = useRef();
  const status = useRef();
  const handleClose = () => setShow(false);
  const [showConfirmacao, setShowConfirmacao] = useState(false);
  const [invalido, setInvalido] = useState(false);
  const [imagensProduto, setImagensProduto] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    function getDados() {
      servicosProduto.listarTodosCategoria3()
        .then(response => {
          if (response.status === 200) {
            setProdutos(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [editado]);

  const handleCloseConfirmacao = () => {
    setShowConfirmacao(false);
  }

  const editarProduto = (nome, tamanho, cor, estoque, milhas, categoria, status) => {
    setEditado(false);
    const data = {
      "nome": nome,
      "tamanho": tamanho,
      "cor": cor,
      "estoque": estoque,
      "milhas": milhas,
      "categoria": categoria,
      "AI": status
    }
    servicosProduto.editar(idProduto, data).then(response => {
      if (response.status === 200) {
        setEditado(true);
        toast.success("Produto alterado com sucesso!", {
          theme: "colored",
        });
        setShowConfirmacao(false);
      }
    }).catch(error => {
      console.log(error);
      toast.error("Não foi possível alterar o Produto!", {
        theme: "colored"
      });
      setShowConfirmacao(false);
    })
    handleClose()
  }



  const handleShow = async (produto) => {
    await servicosImagens.listarPorIdProduto(produto.id_produto).then(response => {
      if (response.status === 200) {
        setImagensProduto(response.data)
      }
    })
    await setInvalido(false);
    await setValor(produto);
    await setIdProduto(produto.id_produto);
    await setShow(true);
  }

  const handleShowConfirmacao = () => {
    const nome = document.querySelector("#nome");
    const estoque = document.querySelector("#estoque");
    const milhas = document.querySelector("#milhas");
    const qtdNome = String(nome.value).length;
    const qtdEstoque = String(estoque.value).length;
    const qtdMilhas = String(milhas.value).length;

    if (qtdNome < 2 || qtdEstoque === 0 || qtdMilhas === 0) {
      setInvalido(true);
    } else {
      setShow(false);
      setShowConfirmacao(true);
    }
  }



  const navigate = useNavigate();

  const checkCategory = (cat) => {
    switch (cat) {
      case 1:
        return "Simples"
      case 2:
        return "Produção"
      default:
        return "Gestores"
    }
  }

  const columnsProdutos = [
    { field: "id_produto", headerName: "ID", width: 45 },
    {
      field: "nome",
      headerName: "Nome",
      width: 120,
      editable: true,
    },
    {
      field: "tamanho",
      headerName: "Tamanho",
      width: 70,
      editable: true,
    },
    {
      field: "categoria",
      headerName: "Categoria",
      width: 100,
      editable: true,
      renderCell: (params) => {
        let cat = params.row.categoria;
        if (cat === 1) {
          return "Simples"
        } else if (cat === 2) {
          return "Produção"
        } else {
          return "Gestores"
        }

      }
    },
    {
      field: "AI",
      headerName: "Status",
      width: 100,
      editable: true,
      renderCell: (params) => {
        let status = params.row.AI;
        if (status === "A") {
          return "Ativo"
        }
        return "Inativo"

      }
    },
    {
      field: "cor",
      headerName: "Cor",
      width: 100,
      editable: true,
    },
    {
      field: "estoque",
      headerName: "Estoque",
      width: 100,
      editable: true,
    },
    {
      field: "milhas",
      headerName: "Milhas",
      width: 100,
      editable: true,
    },
    {
      field: "operacao",
      headerName: "Editar",
      width: 90,
      renderCell: (params) => {
        return <button size="sm" className="rounded btn-icones p-1" onClick={(e) => handleShow(params.row)}><Edit /> Editar</button>
      }
    },
    {
      field: "adicionar",
      headerName: "Edt. Img",
      width: 90,
      renderCell: (params) => {
        return <button className="btn-icones rounded p-1 border-1" onClick={() => navigate("/AdicionarImagem", { state: { produto: params.row } })} ><Edit color="green" /> Edt. Img</button>
      }
    }
  ];

  const onRowsSelectionHandler = (ids) => {
    const selectedRowsData = ids.map((item) => produtos.find((row) => row.id_produto === item.id_produto));
    setSelectedRows(selectedRowsData);
  };

  const actions = [
    { icon: <ShareIcon />, name: 'Exportar Excel' },
  ];

  const handleActionClick = (actionName) => {
    switch (actionName) {
      case 'Exportar Excel':
        handleExportToExcel();
        break;
      default:
        break;
    }
  };

  const handleExportToExcel = () => {
    const selectedRowsIds = selectedRows.map((rowIndex) => rowIndex.id_produto);
    const selectedProducts = produtos.filter((produto) => selectedRowsIds.includes(produto.id_produto));

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Produtos');

    columnsProdutos.forEach((column, index) => {
      if (column.field !== 'operacao' && column.field !== 'adicionar') {
        worksheet.getColumn(index + 1).header = column.headerName;
        worksheet.getColumn(index + 1).key = column.field;
        worksheet.getColumn(index + 1).width = 10;
      }

    });

    selectedProducts.forEach((product) => {
      const rowData = {};
      columnsProdutos.forEach((column) => {
        if (column.field === 'id_produto') {
          rowData[column.field] = product.id_produto;
        } else if (column.field === 'nome') {
          rowData[column.field] = product.nome
        } else if (column.field === 'tamanho') {
          rowData[column.field] = product.tamanho
        } else if (column.field === 'categoria') {
          rowData[column.field] = checkCategory(product.categoria)
        } else if (column.field === 'estoque') {
          rowData[column.field] = product.estoque
        } else if (column.field === 'AI') {
          rowData[column.field] = product.AI === "A" ? "Ativo" : "Inativo"
        } else if (column.field === 'cor') {
          rowData[column.field] = product.cor
        } else if (column.field === 'milhas') {
          rowData[column.field] = product.milhas
        }
      });
      worksheet.addRow(rowData);
    });

    const saveOptions = {
      filename: 'estoque_produtos.xlsx',
      useStyles: true,
      useSharedStrings: true
    };

    workbook.xlsx.writeBuffer().then((buffer) => {
      const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.download = saveOptions.filename;
      link.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
    });
  };

  const SelectCategoria = (props) => {
    return <>
      <select className="form-select mb-4 input-produto" defaultValue={props.categoria} ref={categoria} name="categoria" aria-label="Exemplo de select simples">
        <option value="1">Simples</option>
        <option value="2">Producão</option>
        <option value="4">Gestores</option>
      </select>
    </>
  }

  const SelectStatus = (props) => {
    return <>
      <select className="form-select mb-4 input-produto" defaultValue={props.status} ref={status} name="status" aria-label="Exemplo de select simples">
        <option value="A">Ativo</option>
        <option value="I">Inativo</option>
      </select>
    </>
  }

  const ListaImagens = () => {
    let qtd = imagensProduto.length;
    return <>
      {qtd > 0 ? <div className="d-flex col justify-content align-items-center">
        {imagensProduto.map(item => {
          return <div key={item.filename} className="p-2">
            <img style={{ width: 100 }} src={`${basePath}/${item.filename}`} alt={item.filename} />
          </div>
        })}

      </div> : ""}

    </>
  }

  const SpeedDialShared = () => {
    return (
      <Box sx={{ height: 100, transform: 'translateZ(0px)', flexGrow: 1 }}>
        <SpeedDial
          ariaLabel="SpeedDial"
          sx={{ position: 'absolute', bottom: 38, right: 16, }}
          icon={<SpeedDialIcon />}
          FabProps={{
            sx: {
              bgcolor: '#753BBD',
              '&:hover': {
                bgcolor: '#753BBD',
              }
            }
          }}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={() => handleActionClick(action.name)}
            />
          ))}
        </SpeedDial>
      </Box>
    )
  }

  const ModalConfirmacao = (props) => {
    return <>
      <div >
        <Modal className="modal-confirmaca" show={showConfirmacao} onHide={handleCloseConfirmacao}>
          <Modal.Body className="modal-edicao">
            <span className="mb-3">Você deseja realmente alterar o produto?</span> <br />
            <br></br>
            {props.nome && <p><strong>Nome:</strong> {props.nome}</p>}
            {props.tamanho && <p><strong>Tamanho:</strong> {props.tamanho}</p>}
            {props.cor && <p><strong>Cor:</strong> {props.cor}</p>}
            {props.estoque && <p><strong>Estoque:</strong> {props.estoque}</p>}
            {props.milhas && <p><strong>Milhas:</strong> {props.milhas}</p>}
            {props.categoria && <p><strong>Categoria:</strong> {props.categoria === "1" ? "Simples" : props.categoria === "2" ? "Produção" : "Gestores"}</p>}
            {props.status && <p><strong>Status:</strong> {props.status === "A" ? "Ativo" : "Inativo"}</p>}
          </Modal.Body>
          <Modal.Footer >
            <button type="button" className="btn-icones rounded p-1 w-25" onClick={() => editarProduto(props.nome, props.tamanho, props.cor, props.estoque, props.milhas, props.categoria, props.status)}><Salvar /> Salvar</button>
            <button type="button" className="btn-icones rounded p-1 w-25" onClick={handleCloseConfirmacao}><Cancel /> Voltar</button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  }

  const ModalEditar = () => {
    return <>
      <Modal className="modal-mae  modal-lg" show={show} onHide={handleClose}>
        <Modal.Body className="modal-edicao" >
          <div className="d-flex justify-content-center">
            <Form>
              <div className="">

                <Form.Field className="required ">
                  <label htmlFor="nome" className="form-label label-texto">Nome</label>
                  <input className="input-produto" id="nome" defaultValue={valor?.nome} ref={nome}></input>
                </Form.Field>

                <Form.Field className="">
                  <label htmlFor="tamanho" className="form-label label-texto">Tamanho</label>
                  <input className="input-produto" defaultValue={valor?.tamanho} ref={tamanho}></input>
                </Form.Field>
                <Form.Field className="">
                  <label htmlFor="cor" className="form-label label-texto">Cor</label>
                  <input className="input-produto" defaultValue={valor?.cor} ref={cor}></input>
                </Form.Field>
                <Form.Field className="required">
                  <label htmlFor="estoque" className="form-label label-texto">Estoque</label>
                  <input className="input-produto" id="estoque" defaultValue={valor?.estoque} ref={estoque}></input>
                </Form.Field>
                <Form.Field className="required">
                  <label htmlFor="milhas" className="form-label label-texto">Milhas</label>
                  <input className="input-produto" id="milhas" required defaultValue={valor?.milhas} ref={milhas}></input>
                </Form.Field>
                <Form.Field className=" required">
                  <label htmlFor="categoria" className="form-label label-texto">Categoria</label>
                  <SelectCategoria categoria={valor?.categoria} />
                </Form.Field>
                <Form.Field className=" required">
                  <label htmlFor="status" className="form-label label-texto">Status</label>
                  <SelectStatus status={valor?.AI} />
                </Form.Field>
                <ListaImagens />
                <div className="text-center">
                  <button className="btn-icones rounded p-1 me-2" variant="primary" onClick={handleShowConfirmacao}>
                    <Salvar /> Salvar
                  </button>
                  <button className="btn-icones rounded p-1 " variant="secondary" onClick={handleClose}>
                    <Cancel /> Cancelar
                  </button>
                </div>
                {invalido && <p className="errosValidacao">Ops!!! Um ou mais campos obrigatórios não foram preenchidos.</p>}

              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }

  return (
    <>
      <NavMenu />
      <ToastContainer />
      <ModalConfirmacao className="modal-confirmacao"
        nome={nome?.current?.value}
        tamanho={tamanho?.current?.value}
        cor={cor?.current?.value}
        estoque={estoque?.current?.value}
        milhas={milhas?.current?.value}
        categoria={categoria?.current?.value}
        status={status?.current?.value}
      />
      <div className="d-flex container">
        <div className="w-25">
          <MenuLateral />
        </div>
        <div className="w-75 tabelas-gerenciais">
          <ModalEditar />
          <h3 className="text-start subtitulo" style={{ fontSize: 20 }}>Lista de Produtos</h3>

          <Box sx={{ height: 650, width: 950, marginTop: 2 }}>
            <DataGrid

              style={{ borderRadius: "20px" }}
              localeText={localizedTextsMap}
              rows={produtos}
              columns={columnsProdutos}
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              getRowId={(row) => row.id_produto}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
              }
              checkboxSelection
              onSelectionModelChange={(ids) => {
                const selectedIDs = new Set(ids);
                const selectedRowData = produtos.filter((row) =>
                  selectedIDs.has(row.id_produto)
                )
                onRowsSelectionHandler(selectedRowData);
              }}
            />

            <Box mt={2}>
              <SpeedDialShared />
            </Box>
          </Box>



        </div>
      </div>
    </>
  );
};

export default ListProdutos;